/* src/app/components/identity/login/login.component.scss */
mat-form-field.density-neg-1 {
  --mat-form-field-container-height: 52px;
  --mat-form-field-filled-label-display: block;
  --mat-form-field-container-vertical-padding: 14px;
  --mat-form-field-filled-with-label-container-padding-top: 22px;
  --mat-form-field-filled-with-label-container-padding-bottom: 6px;
}
mat-form-field.density-neg-2 {
  --mat-form-field-container-height: 48px;
  --mat-form-field-filled-label-display: none;
  --mat-form-field-container-vertical-padding: 12px;
  --mat-form-field-filled-with-label-container-padding-top: 12px;
  --mat-form-field-filled-with-label-container-padding-bottom: 12px;
}
mat-form-field.density-neg-3 {
  --mat-form-field-container-height: 44px;
  --mat-form-field-filled-label-display: none;
  --mat-form-field-container-vertical-padding: 10px;
  --mat-form-field-filled-with-label-container-padding-top: 10px;
  --mat-form-field-filled-with-label-container-padding-bottom: 10px;
}
mat-form-field.density-neg-4 {
  --mat-form-field-container-height: 40px;
  --mat-form-field-filled-label-display: none;
  --mat-form-field-container-vertical-padding: 8px;
  --mat-form-field-filled-with-label-container-padding-top: 8px;
  --mat-form-field-filled-with-label-container-padding-bottom: 8px;
}
mat-form-field.density-neg-5 {
  --mat-form-field-container-height: 36px;
  --mat-form-field-filled-label-display: none;
  --mat-form-field-container-vertical-padding: 6px;
  --mat-form-field-filled-with-label-container-padding-top: 6px;
  --mat-form-field-filled-with-label-container-padding-bottom: 6px;
}
mat-paginator.density-neg-1 {
  --mat-paginator-container-size: 52px;
  --mat-paginator-form-field-container-height: 40px;
  --mat-paginator-form-field-container-vertical-padding: 8px;
  --mat-paginator-touch-target-display: block;
}
mat-paginator.density-neg-2 {
  --mat-paginator-container-size: 48px;
  --mat-paginator-form-field-container-height: 40px;
  --mat-paginator-form-field-container-vertical-padding: 8px;
  --mat-paginator-touch-target-display: block;
}
mat-paginator.density-neg-3 {
  --mat-paginator-container-size: 40px;
  --mat-paginator-form-field-container-height: 40px;
  --mat-paginator-form-field-container-vertical-padding: 8px;
  --mat-paginator-touch-target-display: none;
}
mat-paginator.density-neg-4 {
  --mat-paginator-container-size: 40px;
  --mat-paginator-form-field-container-height: 40px;
  --mat-paginator-form-field-container-vertical-padding: 8px;
  --mat-paginator-touch-target-display: none;
}
mat-paginator.density-neg-5 {
  --mat-paginator-container-size: 40px;
  --mat-paginator-form-field-container-height: 36px;
  --mat-paginator-form-field-container-vertical-padding: 6px;
  --mat-paginator-touch-target-display: none;
}
mat-expansion-panel mat-form-field {
  width: 100%;
}
mat-expansion-panel mat-form-field {
  --mat-form-field-container-height: 48px;
  --mat-form-field-filled-label-display: none;
  --mat-form-field-container-vertical-padding: 12px;
  --mat-form-field-filled-with-label-container-padding-top: 12px;
  --mat-form-field-filled-with-label-container-padding-bottom: 12px;
}
mat-expansion-panel mat-form-field .mdc-text-field--filled .mat-mdc-floating-label {
  display: block;
}
mat-expansion-panel mat-form-field .mat-mdc-form-field-infix {
  min-height: 0;
  padding-top: 14px;
  padding-bottom: 2px;
}
mat-expansion-panel mat-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-floating-label {
  top: 21px;
  font-size: 13px;
}
.dark-theme mat-form-field[appearance=outline] {
  --palette-primary-default: #3f51b5;
  --outlined-text-field-outline-color: rgba(255, 255, 255, 0.1);
  --outlined-text-field-hover-outline-color: rgba(255, 255, 255, 0.2);
  --outlined-text-field-focus-outline-color: #8c9eff;
}
.dark-theme mat-form-field[appearance=outline].gold-outline-2 {
  --outlined-text-field-outline-color: rgb(255, 255, 255, 0.2);
  --outlined-text-field-hover-outline-color: rgb(255, 255, 255, 0.4);
  --outlined-text-field-focus-outline-color: #d0a010;
  background: #202020;
}
.dark-theme mat-form-field[appearance=outline].gold-outline-1 {
  --outlined-text-field-outline-color: #705d23;
  --outlined-text-field-hover-outline-color: #b18a16;
  --outlined-text-field-focus-outline-color: #b18a16;
  --form-field-wrapper-background-color: #363636;
}
.dark-theme mat-form-field[appearance=outline].gold-outline-1 .mat-mdc-form-field-input-control {
  caret-color: #b18a16;
}
.dark-theme mat-form-field[appearance=outline].gold-outline-1.mat-mdc-form-field:not(.mat-form-field-disabled).mat-focused .mat-mdc-floating-label.mdc-floating-label {
  color: #b18a16;
}
.dark-theme mat-form-field[appearance=outline].gold-outline-1.mat-focused span.mat-mdc-form-field-required-marker.mdc-floating-label--required::after {
  color: #b18a16;
}
.dark-theme mat-form-field[appearance=outline].error-outline.mat-form-field-invalid {
  --outlined-text-field-outline-color: #d23030;
  --outlined-text-field-hover-outline-color: #d23030;
}
.dark-theme mat-form-field[appearance=outline].brighter-outline-1:not(.mat-form-field-invalid) {
  --outlined-text-field-outline-color: rgba(255, 255, 255, 0.25);
  --outlined-text-field-hover-outline-color: rgba(255, 255, 255, 0.45);
}
.dark-theme mat-form-field.mat-form-field-invalid.mat-focused span.mat-mdc-form-field-required-marker.mdc-floating-label--required::after {
  color: var(--mdc-filled-text-field-error-focus-label-text-color);
}
:host ::ng-deep .mat-mdc-progress-spinner circle,
.mat-mdc-progress-spinner circle {
  stroke: #fff;
}
.forgot-password-link {
  color: #3f51b5;
}
.sign-in-error {
  color: #f44336;
}
:host-context(.dark-theme) :host ::ng-deep .mat-mdc-input-element {
  caret-color: #b18a16;
}
:host-context(.dark-theme) .forgot-password-link {
  color: #D0A010;
}
:host-context(.dark-theme) .sign-in-error {
  color: #ff5b4f;
}
:host-context(.dark-theme) .mat-mdc-raised-button.mat-primary {
  background-color: #D0A010;
  color: rgba(0, 0, 0, 0.87);
}
:host-context(.dark-theme) :host ::ng-deep .mat-mdc-progress-spinner circle,
:host-context(.dark-theme) .mat-mdc-progress-spinner circle {
  stroke: black;
}
#username-input.mat-body-strong,
#password-input.mat-body-strong {
  font-size: 16px;
  line-height: 28px;
}
/*# sourceMappingURL=login.component.css.map */
